import { Box, Typography, Divider } from "@mui/material";
import { FuncionariosTable } from "../../funcionarios/funcionariosTable";


export const FuncionarioConfig: React.FC = () => {
  return (
    <Box sx={{ width: "100%", height: 'calc(100vh - 3em)', display: "flex", flexDirection: "column" }}>
      <Typography
        fontWeight="bold"
        fontSize="1.5em"
        sx={{ px: "0.5em" }}
      >
        Funcionários
      </Typography>
      <Divider />

      <Box sx={{ flex: 1, height: 'calc(100vh - 5.5em)' }}>
        <FuncionariosTable isRegister isSendPassword />
      </Box>
    </Box>
  );
};
